export enum OnboardingStatus {
  APPROVED = 'Approved',
  UNCOMPLETED = 'Uncompleted',
  PASSED = 'Passed'
}
